// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

interface ImpersonationData {
  access_token: string;
  refresh_token: string;
  user_id: string;
  athlete_profile_id: string;
  parent_user_id: string;
  parent_session: any;
  athlete_id: string;
}

export function useImpersonation() {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [athleteId, setAthleteId] = useState<string | null>(null);
  const { setProfile } = useAuth();

  useEffect(() => {
    const checkImpersonation = async () => {
      const storedData = localStorage.getItem('impersonation-tokens');
      
      if (storedData) {
        try {
          const impersonationData: ImpersonationData = JSON.parse(storedData);
          
          console.log('🔄 Restoring impersonation session...');
          
          // Get the athlete's profile using the stored athlete_profile_id
          const { data: profile, error } = await supabase
            .from('profiles')
            .select('*')
            .eq('id', impersonationData.athlete_profile_id)
            .single();

          if (error || !profile) {
            console.error('❌ Failed to get athlete profile:', error);
            localStorage.removeItem('impersonation-tokens');
            return;
          }

          console.log('✅ Setting athlete profile for impersonation:', profile.name);
          setProfile(profile);
          setIsImpersonating(true);
          setAthleteId(impersonationData.athlete_id);
          
          // Add redirect logic here - check if we're not already on athlete dashboard
          const currentPath = window.location.pathname;
          if (!currentPath.includes('/athlete-dashboard')) {
            console.log('🔄 Redirecting to athlete dashboard from impersonation...');
            window.location.href = '/athlete-dashboard';
            return;
          }
          
          console.log('✅ Impersonation session restored successfully');
          
        } catch (error) {
          console.error('❌ Error restoring impersonation:', error);
          localStorage.removeItem('impersonation-tokens');
        }
      }
    };

    checkImpersonation();
  }, [setProfile]);

  const exitImpersonation = async () => {
    try {
      console.log('🔄 Exiting impersonation...');
      
      localStorage.removeItem('impersonation-tokens');
      
      setIsImpersonating(false);
      setAthleteId(null);
      
      console.log('✅ Impersonation ended, redirecting to parent dashboard');
      
      // Redirect back to parent dashboard
      window.location.href = '/parent-dashboard';
    } catch (error) {
      console.error('❌ Error exiting impersonation:', error);
      // Force redirect even if there's an error
      window.location.href = '/parent-dashboard';
    }
  };

  return {
    isImpersonating,
    athleteId,
    exitImpersonation,
  };
}
